<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <g fill="currentColor">
      <path d="M10.5 14.2l3.9-2.2-3.9-2.2z" />
      <path
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm7.5 12s0 2.4-.3 3.6c-.2.6-.7 1.1-1.3 1.3-1.2.3-5.9.3-5.9.3s-4.7 0-5.9-.3c-.6-.2-1.1-.7-1.3-1.3-.3-1.2-.3-3.6-.3-3.6s0-2.4.3-3.6c.2-.7.7-1.2 1.3-1.3 1.2-.4 5.9-.4 5.9-.4s4.7 0 5.9.3c.6.2 1.1.7 1.3 1.3.3 1.3.3 3.7.3 3.7z"
      />
    </g>
  </svg>
</template>
